import React, { useEffect, useRef, useState } from "react";

import { IoClose } from "react-icons/io5";

const Modal = ({ isOpen, onClose, type, title, content, placeholder, inputValue, onConfirm, updateInputValue, buttonText }) => {
    const modalRef = useRef(null);
    const [show, setShow] = useState(false);
    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setShow(true);
            setTimeout(() => setAnimate(true), 10);
            document.body.style.overflow = "hidden";
        } else {
            setAnimate(false);
            setTimeout(() => setShow(false), 300);
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    const handleOutsideClick = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            onClose();
        }
    };

    if (!show) return null;

    return (
        <div className={`modal-overlay flex-center z-50 animate-ease ${
            animate ? "opacity-100" : "opacity-0" }`}
            onClick={handleOutsideClick}
        >
            <div
                ref={modalRef}
                className={`relative w-[90%] max-w-sm overflow-y-auto bg-main-gradient p-4 rounded-lg shadow-lg animate-ease ${
                    animate ? "opacity-100" : "opacity-0" }`}
            >
                <div className="flex-between">
                    <p className="text-sm font-bold text-white">
                        {title}
                    </p>
                    <button className="animate-rotate"
                        onClick={onClose}
                    >
                        <IoClose className="size-sm animate-rotate text-color-blue opacity-100 rotate-0 scale-100" />
                    </button>
                </div>

                {type === "formInput" ? (
                    <div className="flex-col">
                        <p className="mb-6 text-color-white-opacity font-sm">
                            {placeholder}
                        </p>
                        <input
                            type="text"
                            value={inputValue}
                            onChange={(e) => updateInputValue(e.target.value)}
                            placeholder={placeholder}
                            className="w-full cursor-pointer bg-secondary container-equal-sm text-white focus:outline-none placeholder:text-sm rounded-md mb-3"
                        />
                        <div className="flex py-4">
                            <button className="flex-grow btn-gradient-border container-lg font-bold font-sm rounded-sm"
                                onClick={() => {
                                    if (onConfirm) onConfirm(inputValue);
                                    onClose();
                                }}
                            >
                                {buttonText}
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="text-white">
                        {content}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Modal;